<template>
  <VView class="menu">
    <VBlock max-width="111px">
      <img src="@/assets/stars.png" />
    </VBlock>

    <hr />

    <VText center big>
      Pokaż nam jak spędzasz czas<br />
      z Przyjaciółmi na Comedy Central
    </VText>

    <hr />

    <VBlock max-width="460px">
      <transition :name="getButtonTransitionName(item, index)"
        v-for="(item, index) in items" :key="index"
        appear
      >
        <VButton :to="item.to" :alternative="!isLastButton(index)">{{ item.label }}</VButton>
      </transition>
    </VBlock>
  </VView>
</template>

<script>
export default {
  name: 'Menu',

  data() {
    return {
      items: [
        { to: '/rules', label: 'Zasady' },
        { to: '/prizes', label: 'Nagrody' },
        { to: '/gallery', label: 'Galeria' },
        { to: '/quiz', label: 'Quiz wiedzy' },
        { to: '/winners', label: 'Laureaci' },
      ],
    };
  },

  methods: {
    getButtonTransitionName(item, index) {
      return index % 2 === 0
        ? 'bounceLeft'
        : 'bounceRight';
    },

    isLastButton(index) {
      return index === this.items.length - 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.menu {}
</style>
